export default __webpack_public_path__ + "fonts/solution-img2.svg";